import React from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { formatDateWithMonth } from "../../../../utils/helperFunction";

export default function ProductDetailsButtonView() {
  const { quichReportData } = useSelector((state) => state.QUICKREPORT);
  return (
    <div className="d-flex flex-column" style={{ rowGap: "10px" }}>
      <div className="btns_row">
        <Button type="submit" className="custom-continue-button flex-grow-1">
          <span className="fw-bold"> Product Code</span>
          <span className="value_span">
            {quichReportData?.kit_data?.product_code}
          </span>
        </Button>
        <Button type="submit" className="custom-continue-button flex-grow-1">
          <span className="fw-bold"> LOT Number</span>
          <span className="value_span">
            {quichReportData?.kit_data?.lot_number}
          </span>
        </Button>
        <Button type="submit" className="custom-continue-button flex-grow-1">
          <span className="fw-bold"> Expiry Date</span>
          <span className="value_span">
            {quichReportData?.kit_data?.expiry_date &&
              formatDateWithMonth(quichReportData?.kit_data?.expiry_date)}
          </span>
        </Button>
      </div>
      <div className="btns_row">
        <Button type="submit" className="custom-continue-button">
          <span className="fw-bold"> Installed Location</span>
          <span className="value_span">
            {quichReportData?.kit_data?.location_name &&
              quichReportData?.kit_data?.location_name}
          </span>
        </Button>
        <Button type="submit" className="custom-continue-button">
          <span className="fw-bold"> Installed Area</span>{" "}
          <span className="value_span">
            {quichReportData?.kit_data?.area && quichReportData?.kit_data?.area}
          </span>
        </Button>
      </div>
    </div>
  );
}
